{
  "version": 1,
  "asset_id": "d991b6bb-a616-4838-98bd-53c1042f8a83",
  "project_id": "ba939065-ecb3-4567-a218-3200eee84f15",
  "url": "/__l5e/assets-v1/d991b6bb-a616-4838-98bd-53c1042f8a83/letter525.jpg",
  "r2_key": "a/v1/ba939065-ecb3-4567-a218-3200eee84f15/d991b6bb-a616-4838-98bd-53c1042f8a83/letter525.jpg",
  "original_filename": "letter525.jpg",
  "size": 102044,
  "content_type": "image/jpeg",
  "created_at": "2026-06-15T15:38:49Z"
}
